// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
import axios from './axios'
import App from './App'
import router from './router'
import qs from 'qs'
import global from './components/utils/Global.vue'
import sdk from './components/utils/sdk.vue'

import 'ant-design-vue/dist/antd.css';
import AntDesignUI from 'ant-design-vue';
import {
  message
} from 'ant-design-vue';
import store from './store/index'

Vue.prototype.$msg = message;
Vue.use(AntDesignUI);
Vue.component('sdk-view', sdk);
Vue.config.productionTip = false;

// axios.defaults.withCredentials = true;
Vue.prototype.$axios = axios // 全局注册，使用方法为:this.$axios
Vue.prototype.$qs = qs // 全局注册，使用方法为:this.$qs
Vue.prototype.$store = store // 全局注册，使用方法为:this.$qs

var ua = navigator.userAgent;
var mobile = !!ua.match(/AppleWebKit.*Mobile.*/);



QHPass.init({
  src: "pcw_monitorzyun",
  primaryColor: "#4B93FF",
  signIn: {
    types: ["normal", "mobile"],
    normal: {
      onlyMobile: true
    },
    panelLogo: 'https://p5.ssl.qhimg.com/t0118201864d21bcf2e.png',
    hideKeepAlive: false,
    "thirdPart": {
      "providers": []
    },
  },
  signUp: {
    "protocolUrl": "https://demo.entlive.360.cn/service.html",
    "privacyUrl": "https://demo.entlive.360.cn/secret.html",
    "hidePasswordAgain": false
  }
});
router.beforeEach((to, from, next) => {
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    $('body').html('请在浏览器中打开');
    return;
  }
  if (to.name == 'seeClass') {
    next();
    return
  }
  if (global.userInfo) {
    if (to.name == '/' || to.name == "" || to.name == 'main' || to.name == 'login' || to.path == '/main' || to.name == 'mlogin') {
      if (mobile) {
        router.push('/mdevice');
      } else {
        router.push('/device');
      }
    }
    next();
  } else {
    if (global.isJumpingToLogin) {
      next();
      return;
    }
    QHPass.getUserInfo(
      function (data) {
        global.userInfo = data;
        if (to.name == '/' || to.name == "" || to.name == 'main' || to.name == 'login' || to.path == '/main' || to.name == 'mlogin') {
          if (mobile) {
            router.push('/mdevice');
          } else {
            router.push('/device');
          }
        }
        next();
      },
      function (err) {
        global.userInfo = null;
        global.isJumpingToLogin = true;
        if (mobile) {
          if (to.name == 'device') {
            to.name = 'mdevice';
          }
          router.push({
            path: '/mlogin?to=' + to.name,
          });
        } else {
          router.push({
            path: '/login?to=' + to.name,
          });
        }
        next();
      }
    );
  }
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js